module.exports = "<nav role=\"navigation\" class=\"my-lists-container navigation\">\r\n    <wow-saved-lists></wow-saved-lists>\r\n    <wow-past-shop-list></wow-past-shop-list>\r\n    <wow-suggested-list></wow-suggested-list>\r\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/lists/views/lists.html
// module id = 624
// module chunks = 0